import { ComponentType } from 'react';

// tslint:disable-next-line:no-any
export const getComponentDisplayName = (Component: ComponentType<any>): string =>
  Component.displayName || Component.name || 'Component';
